import {
  spaceCadet,
} from '@cogneed/react-utils';
import { Box, alpha, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 2,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: spaceCadet[600],
  gap: 8,

  '& a': {
    color: spaceCadet[100],
    padding: 6,
    fontSize: 16,
    borderRadius: 4,
    '&.isActive': {
      backgroundColor: alpha('#fff', 0.25),
      '&:hover': {
        backgroundColor: alpha('#fff', 0.4),
      },
    },
    '&:hover': {
      backgroundColor: alpha('#fff', 0.4),
    },
    '& svg': {
      display: 'block',
      fontSize: 'inherit',
    },
  },
}));

export default StyledBox;
